import { EMastraAgentId, zSchema } from "@zeal/common";

export const postAiStreamUiMessageSchema = zSchema
  .object({
    id: zSchema.string(),
    role: zSchema.string(),
    parts: zSchema.array(zSchema.unknown()),
  })
  .passthrough();

export type TPostAiStreamUiMessage = zSchema.infer<
  typeof postAiStreamUiMessageSchema
>;

export const postAiStreamRequestSchema = zSchema.object({
  companyId: zSchema.string().min(1),
  conversationId: zSchema.string().min(1).optional(),
  messages: zSchema.array(postAiStreamUiMessageSchema).min(1),
  userId: zSchema.string().min(1),
  clientTimeZone: zSchema.string().min(1).optional(),
  scope: zSchema.string().min(1).optional(),
  persistLongTermMemory: zSchema.boolean().optional(),
  metadata: zSchema.record(zSchema.string(), zSchema.any()).optional(),
  trigger: zSchema.string().optional(),
  messageId: zSchema.string().optional(),
  runId: zSchema.string().min(1).optional(),
  resumeData: zSchema.any().optional(),
  agentId: zSchema.nativeEnum(EMastraAgentId).optional(),
});

export type TPostAiStreamRequestSchema = zSchema.infer<
  typeof postAiStreamRequestSchema
>;
